import React from 'react';
import { useTranslation } from 'react-i18next';
import './LoadingSpinner.css'

const LoadingSpinner = ({login}) => {
  let loginStyles = {
    fontSize:'18px',
    color:'white',
    fontWeight:800,
  }
  const { t, i18n } = useTranslation();
  return (
  <div className={`spinner ${login ? 'login_page_alignment' : 'alignment'}`}>
  <span style={login && loginStyles}className = "span">{t("loading")}<span>
    <div className={i18n.language == "chi" ? "half-spinner1" : "half-spinner"}>
      </div></span>{t("wait")}</span>
  </div>
  )
};

export default LoadingSpinner;